"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableCardStyled = void 0;
// styles
const Theme_1 = require("../../Theme/Theme");
// components
const ExpandableCard_1 = require("../Card/ExpandableCard");
exports.ExpandableCardStyled = Theme_1.styled(ExpandableCard_1.ExpandableCard) `
  margin-bottom: ${(props) => ((props === null || props === void 0 ? void 0 : props.noGutter) ? '1px !important' : '')};
`;
//# sourceMappingURL=Accordion.styles.js.map